import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateRolesApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateRoleList = createAsyncThunk('updateRoleList', async (payload) => {
  return await updateRolesApi(payload);
});

const updateRoleListSlice = createSlice({
  name: 'updateRoleList', // Unique Name
  initialState,
  reducers: {
    updateRoleListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateRoleList.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateRoleList.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateRoleList.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateRoleListReset } = updateRoleListSlice.actions;

export default updateRoleListSlice.reducer;
